const fonts = {
  mainFont: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  serif: 'PT Serif',
  // Roboto Mono is loaded from Google Fonts (index.css). The generic monospace
  // fallback ensures the browser picks a monospace font instead of the
  // default serif/sans-serif if the CDN is blocked or the font fails to load.
  mono: "'Roboto Mono', monospace",
} as const;

export default fonts;
